import Vue from 'vue';
import App from './App.vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import vueMoment from 'vue-moment';
import VueTelInput from 'vue-tel-input';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, email, numeric } from 'vee-validate/dist/rules';
import VueI18n from 'vue-i18n';
import { messages } from './lang/translations';
import './styles/style.sass';
import { BaseComponents } from '@/basecomponents/BaseComponents.js';
import { mixinRoles } from '@/mixins/Roles';
import { mixinNumbers } from '@/mixins/Numbers';

Vue.config.productionTip = false;
Vue.use(VueAxios, axios);
Vue.use(VueI18n);
Vue.filter('money', value => `${value.toLocaleString(undefined,
    { minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'EUR' },
)}`);

// registration BaseComponents
Object.keys(BaseComponents).forEach(fileName => {
  const componentConfig = BaseComponents[fileName]
  Vue.component(
    fileName,
    componentConfig.default || componentConfig
  )
});

// VueTelInput
Vue.use(VueTelInput);

// I18n
const i18n = new VueI18n({
  locale: 'es',
  messages,
})

// VeeValidate
extend('required', {
  ...required,
  message:  (_, values) => i18n.t('validations.required', values)
});
extend('email', {
  ...email,
  message:  (_, values) => i18n.t('validations.email', values)
});
extend('numeric', {
  ...numeric,
  message:  (_, values) => i18n.t('validations.numeric', values)
});
extend('min_float', {
  params: ['min'],
  validate(value, args) {
    if(/^[0-9]+(\.[0-9]+)?$/.test(value)){
      return parseFloat(value) >= parseFloat(args.min);
    } else {
      return false;
    }
  },
  message:  (_, values) => i18n.t('validations.float.hint_min', values)
});
extend('max_float', {
  params: ['max'],
  validate(value, args) {
    if(/^[0-9]+(\.[0-9]+)?$/.test(value)){
      return parseFloat(value) < parseFloat(args.max);
    } else {
      return false;
    }
  },
  message:  (_, values) => i18n.t('validations.float.hint_max', values)
});
extend('decimals_float', {
  params: ['decimals'],
  validate(value, args) {
    if(/^[0-9]+(\.[0-9]+)?$/.test(value)){
      if(value.split('.').length>1){
        return value.split('.')[1].length <= parseInt(args.decimals);
      } else {
        return true;
      }
    } else {
      return false;
    }
  },
  message:  (_, values) => i18n.t('validations.float.hint_decimals', values)
});
extend('min_value', {
  params: ['min'],
  validate(value, args) {
    return parseInt(value) >= parseInt(args.min);
  },
  message:  (_, values) => i18n.t('validations.min_value', values)
});
extend('max_value', {
  params: ['max'],
  validate(value, args) {
    return parseInt(value) <= parseInt(args.max);
  },
  message:  (_, values) => i18n.t('validations.max_value', values)
});
extend('ip', {
  validate(value) {
    // eslint-disable-next-line no-useless-escape
    if(value.match(/^((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.)|\*\.){3}(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])|\*)$/)){
      return true;
    }else{
      return false;
    }
  },
  message:  (_, values) => i18n.t('validations.ip', values)
});
extend('host', {
  validate(value) {
    // eslint-disable-next-line no-useless-escape
    if(value.match(/(http(s?):\/\/)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/i)){
      return true;
    }else{
      return false;
    }
  },
  message:  (_, values) => i18n.t('validations.host', values)
});
extend('phone', {
  validate(value, args) {
    return args.isValid == 'true';
  },
  params: ['isValid'],
  message:  (_, values) => i18n.t('validations.phone', values)
});
extend('categoryPercentage', {
  validate(value) {
    // eslint-disable-next-line no-useless-escape
    if(value == 100){
      return true;
    }else{
      return false;
    }
  },
  message:  (_, values) => i18n.t('validations.categoryPercentage', values)
});

Vue.filter('completeZero', function (value, digits){
  let out = value;
  if(typeof value === 'number' || typeof value === 'string'){
    if(value.toString().length < digits){
      for (let i=0, len=(digits - value.toString().length) ; i<len ; i++){
        out = '0'+ out;
      }
    }
  }
  return out;
});

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

// Using moment.js
Vue.use(vueMoment);

// loading general methods
Vue.mixin(mixinRoles);
Vue.mixin(mixinNumbers);

// App
const vm = new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
})

vm.$mount('#app');
